import { ReactElement } from 'react';

import { Container as MUIContainer } from '@mui/material';

import { ContainerProps } from './types';

export default function Container({ children, ...rest }: ContainerProps): ReactElement {
  return (
    <MUIContainer {...rest} maxWidth='lg'>
      {children}
    </MUIContainer>
  );
}
